export default __webpack_public_path__ + "static/media/bzen.553fd0da.jpg";